import { useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Layout from "@/components/layout/Layout";
import { Button } from "@/components/ui/button";
import { CheckCircle2 } from "lucide-react";
import { useCart } from "@/context/CartContext";

export default function OrderSuccess() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");
  const { clearCart } = useCart();

  useEffect(() => {
    clearCart();
  }, [clearCart]);

  return (
    <Layout>
      <div className="container flex flex-col items-center py-24 text-center">
        <CheckCircle2 className="h-20 w-20 text-accent" />
        <h1 className="mt-6 font-display text-3xl font-bold">Order Confirmed!</h1>
        <p className="mt-3 max-w-md text-muted-foreground">
          Thank you for your purchase. You'll receive a confirmation email shortly with your order details.
        </p>
        {sessionId && (
          <p className="mt-2 text-xs text-muted-foreground">
            Order reference: <span className="font-mono">{sessionId.slice(-8).toUpperCase()}</span>
          </p>
        )}
        <Button asChild className="mt-8 bg-accent text-accent-foreground hover:bg-accent/90">
          <Link to="/shop">Continue Shopping</Link>
        </Button>
      </div>
    </Layout>
  );
}
